import { render } from "./text-list.vue?vue&type=template&id=142a2629&scoped=true"
import script from "./text-list.vue?vue&type=script&lang=js"
export * from "./text-list.vue?vue&type=script&lang=js"

import "./text-list.vue?vue&type=style&index=0&id=142a2629&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-142a2629"]])

export default __exports__